import request from "helpers/api_helper";
import { toast } from "react-toastify";

export const getDiscounts = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `discounts${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch discounts");
    return error;
  }
};

export const createDiscount = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "discounts",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Discount created successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to create discount");
    return error;
  }
};

export const updateDiscount = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `discounts/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Discount updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update discount");
    return error;
  }
};

export const deleteDiscount = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `discounts/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Discount deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete discount");
    return error;
  }
};

export const getDiscountById = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `discounts/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch discount");
    return error;
  }
};

export const getDiscountTypes = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "discount_types",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch discount types");
    return error;
  }
};

export const getDiscountValidityOptions = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "discount_validities",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch discount validity options");
    return error;
  }
};

export const getDiscountScopes = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "discount_scopes",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch discount scopes");
    return error;
  }
};

export const checkDiscountCode = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `discounts/check`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    return error;
  }
}